<template>
  <div class="account-layout">
    <toolbar/>
    <account-bar/>
    <div class="account-layout__inner">
      <slot/>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
import AccountBar from '@/components/navigation/AccountBar.vue'
import Toolbar from '@/components/navigation/Toolbar.vue'
import FooterBar from '@/components/navigation/FooterBar.vue'

export default {
  name: 'AccountLayout',
  components: {
    AccountBar,
    FooterBar,
    Toolbar,
  },
}
</script>

<style lang="scss">
.account-layout__inner {
  min-height: 60vh;
}
</style>
